module.exports = __webpack_public_path__ + "static/media/UnderConstruction.e692dfa0.png";